import axios from 'axios'
import { portalAuthHttpClient } from '../utils/HttpRequestUtils'
import envConfigs from '../configs/envConfigs'

export const getListTemplateNamesResponse = async (data) => {
	const url = `${envConfigs.baseUrl}${envConfigs.getTemplateListUrl}`
	const response = await portalAuthHttpClient.post(url, data)
    return response.data
}
